<template>
  <div style="width: 100%"
    class="fill-height">
    <!-- <v-row class="pt-3 pr-3">
      <v-spacer></v-spacer>
      <Search-box
        :emitDestination="searchEmitDestination"
        searchPlaceholder="Pretraži artikle"
      ></Search-box
    ></v-row> -->
    <v-container class="pt-0">
      <v-row v-if="listView"
        style="margin-top: 0px"
        class="d-flex justify-center">
        <v-col cols="12"
          sm="11"
          lg="11"
          :class="['px-0']">
          <div class="fields-rows-body">
            <v-card v-for="(field, i) in fields" :key="i"
              :class="['field-card', getStatusClass(field)]">
              <v-row class="ma-0 align-center" style="min-height: 60px;">
                <div style="width: 18%; padding: 8px 16px; min-width: 0; overflow: hidden;">
                  <div class="field-name one-liner-text">{{ $options.filters.capitalize(field.label) }}</div>
                </div>
                <div style="width: 22%; padding: 8px 16px; min-width: 0; overflow: hidden;">
                  <div class="field-cell one-liner-text">{{ showType(field.field_type) }}</div>
                </div>
                <div style="width: 10%; padding: 8px 16px;">
                  <div class="field-cell text-center">{{ field.mandatory ? 'DA' : 'NE' }}</div>
                </div>
                <div style="width: 16%; padding: 8px 16px; min-width: 0; overflow: hidden;">
                  <div class="field-cell one-liner-text">{{ field.default_value }}</div>
                </div>
                <div style="width: 14%; padding: 8px 16px;">
                  <div class="field-cell text-center">{{ field.printable ? 'DA' : 'NE' }}</div>
                </div>
                <div style="flex: 1; padding: 8px 16px;">
                  <v-chip x-small :class="getStatusChipClass(field)">{{ field.status }}</v-chip>
                </div>
                <div style="padding: 8px 8px; display: flex; align-items: center;">
                  <v-menu bottom left offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on" @click.stop>
                        <v-icon color="#94A3B8">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item :disabled="field.status !== 'OK'" @click="openEditField(field)">
                        <v-list-item-icon class="mr-2"><v-icon small color="#3989C9">mdi-pencil</v-icon></v-list-item-icon>
                        <v-list-item-title>Uredi</v-list-item-title>
                      </v-list-item>
                      <v-list-item :disabled="field.status !== 'OK'" @click="deleteField(field)">
                        <v-list-item-icon class="mr-2"><v-icon small color="#F87171">mdi-delete</v-icon></v-list-item-icon>
                        <v-list-item-title>Obriši</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-row>
            </v-card>
          </div>
        </v-col>
        <add-field ref="addField"
          @refreshFields="refresh()"></add-field>
        <edit-field ref="editField"
          @refreshFields="refresh()"></edit-field>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { df, functions } from '@/plugins/firebase'
import state from '@/state'
import flow from '@/mixins/flow'
import applicationSettings from '@/mixins/applicationSettings' // don't move.. detaches firebase listeners
import barcodeChecker from '@/mixins/barcodeChecker'
// import EventBus from '@/plugins/event-bus'
import AddField from '@/modules/point-of-sale/components/workorder/AddField'
import EditField from '@/modules/point-of-sale/components/workorder/EditField'

export default {
  name: 'Fields',
  inject: ['showLoader', 'hideLoader'],
  mixins: [flow, applicationSettings, barcodeChecker],
  components: { AddField, EditField },
  data: () => ({
    dialog: false,
    loading: false,
    totalArticles: 0,
    lastiItem: false,
    fields: [],
    listeners: [],
    multiplier: 0,
    selectedLocation: undefined,
    locations: [],
    showLocationSelector: false,
    choosenText: '',
    innerSearch: undefined,
    barcode: [],
    // searchEmitDestination: 'locationStaffSearch',
    lastDocSnapshot: null
  }),
  computed: {
    listView () {
      return state.isListView()
    },
    search () {
      return state.search
    }
  },
  watch: {
    listView (nv, ov) {
      if (nv !== ov) {
        if (this.$refs.InfiniteLoading) {
          this.$refs.InfiniteLoading.stateChanger.reset()
        }
      }
    }
  },
  async mounted () {
    // DOHVATI SVE LOKACIJE ZA FIRMU
    // await this.getLocations()

    // EventBus.$on(this.searchEmitDestination, (searchObject) => {
    //   if (!searchObject.triGramObject) {
    //     this.lastDocSnapshot = null
    //     this.detachListeners()
    //     this.resetHandler()
    //   } else {
    //     this.getStaffNew(searchObject.triGramObject)
    //   }
    // })

    this.getField()
  },
  methods: {
    showType (fieldType) {
      switch (fieldType) {
        case 'textfield':
          return 'Polje za unos teksta'
        case 'textarea':
          return 'Veliko polje za unos teksta'
        case 'dropdown':
          return 'Odabir predefiniranih vrijednosti'
        case 'checkbox':
          return 'Potvrdni okvir'
        case 'radio':
          return 'Radio gumb'
        case 'date':
          return 'Datum'
      }
      return ''
    },
    refresh () {
      setTimeout(() => {
        this.fields = []
        this.getField()
        this.$forceUpdate()
      }, 1000)
    },

    openAddField () {
      if (this.fields && this.fields.length > 0) {
        const maxOrderNumber = Math.max(...this.fields.map(field => field.order_number))
        this.$refs.addField.open(maxOrderNumber + 1)
      } else {
        this.$refs.addField.open(1)
      }
    },

    openEditField (field) {
      this.$refs.editField.open(field)
    },

    deleteField (field) {
      this.confirm({
        title: 'Brisanje',
        message: `Jeste li sigurni da želite obrisati polje '${field.label}'?`,
        options: {
          toolbar: true,
          width: 410,
          confirmText: 'OBRIŠI',
          cancelText: 'ODUSTANI'
        }
      }).then(async (resp) => {
        this.showLoader()
        this.confirmClose()
        if (resp) {
          var workorderApi = functions.httpsCallable('workorderapi')

          var params = {
            action: {
              operation: 'delete',
              entity: 'field',
              resource_id: '',
              params: {
                id: field.id,
                company_id: state.getCurrentCompany().id
              }
            }
          }

          workorderApi(
            params
          )
            .then((result) => {
              this.hideLoader()
              if (result.data.code === 200) {
                this.refresh()
                this.showMsgBox({
                  text: 'Uspješna izmjena',
                  actions: ['cancel'],
                  cancelBtnText: 'OK',
                  color: 'error'
                })
              } else {
                this.showMsgBox({
                  text: 'Dogodila se greška, neuspješna izmjena',
                  actions: ['cancel'],
                  cancelBtnText: 'OK',
                  color: 'error'
                })
              }
            })
        } else {
          this.confirmClose()
        }
      })
    },

    async getField () {
      const snapshot = await df.doc(`workorder_fields/${state.getCurrentCompany().id}`).get()
      if (snapshot) {
        const document = snapshot.data()

        this.fields = Object.keys(document.fields).map(key => {
          return { ...document.fields[key] }
        })

        this.fields.sort((a, b) => a.label > b.label ? 1 : -1)
      }
    },

    getLocations () {
      this.showLocationSelector = false

      df.collection('locations')
        .where('company_id', '==', state.getCurrentCompany().id)
        .get()
        .then((documentSnapshots) => {
          if (documentSnapshots.docs && !documentSnapshots.docs.empty) {
            documentSnapshots.docs.forEach((location) => {
              const loc = location.data()
              this.locations.push(loc)
              if (state.getPointOfSale().id !== undefined && loc.id === state.getPointOfSale().id) {
                this.selectedLocation = loc
                this.getStaffNew()
              }
            })
          }
        })
    },

    getStatusClass (field) {
      if (field.status === 'OK') return 'field-status-ok'
      if (field.status === 'PROCESSING') return 'field-status-warn'
      return 'field-status-failed'
    },
    getStatusChipClass (field) {
      if (field.status === 'OK') return 'field-chip-ok'
      if (field.status === 'PROCESSING') return 'field-chip-warn'
      return 'field-chip-failed'
    },
    hoverOver (ref, item) {
      const container = this.$refs[ref]
      if (!container || !container[0]) return
      if (container[0].clientHeight < container[0].scrollHeight) {
        item[ref] = true
      }
    },

    openDialog () {
      this.dialog = true
    }

  }
}
</script>
<style scoped>
.fields-rows-body {
  background: #F5F7FA;
  padding: 6px 0 2px;
}

.field-card {
  border: 1px solid #EEF2F5 !important;
  border-left: 3px solid #E0E0E0 !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  box-shadow: none !important;
  overflow: hidden !important;
  margin-bottom: 4px !important;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.field-card:hover {
  border-color: #00BCD4 !important;
  background: #F8FAFB !important;
}

.field-card.field-status-ok     { border-left-color: #4ADE80 !important; }
.field-card.field-status-warn   { border-left-color: #FBBF24 !important; }
.field-card.field-status-failed { border-left-color: #F87171 !important; }

.field-name {
  font-size: 15px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
}

.field-cell {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.87);
}

.field-chip-ok     { background-color: #DCFCE7 !important; color: #166534 !important; }
.field-chip-warn   { background-color: #FEF9C3 !important; color: #854D0E !important; }
.field-chip-failed { background-color: #FEE2E2 !important; color: #991B1B !important; }
</style>
